<template>
  <section class="pip-section">
    <VueDraggableResizable class="pip-draggable-container" drag-handle=".drag" :x="left" :y="top" :w="width" :h="height" @resizing="resize" @dragging="drag">
      <div class="pip-content-wrapper">
        <div class="pip-frame-overlay-handle drag" v-if="useOverlayHandle"></div>
        <VideoJSPlayer :options="{ autoplay: true, controls: true, sources: [{ src: source, type: 'application/x-mpegURL' }] }" v-if="useVJS" />
        <iframe class="pip-iframe" :src="source" frameborder="0" allow="autoplay; fullscreen" v-else></iframe>
        <div class="pip-close-pip drag">
          <!-- <i class="far fa-window-minimize" @click="closePIP"></i> -->
          <i class="far fa-window-minimize" @click="enterMiddleSize" v-if="currentMode == 'full'"></i>
          <i class="far fa-window-maximize" @click="enterFullSize" v-if="currentMode == 'middle'"></i>
          <i class="fas fa-times" @click="closePIP"></i>
        </div>
      </div>
    </VueDraggableResizable>
  </section>
</template>

<script>
import VideoJSPlayer from '@/components/general/VideoJSPlayer.vue';
import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';

export default {
  name: 'PIP',
  components: { VueDraggableResizable, VideoJSPlayer },
  props: {
    source: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      left: 0,
      top: 0,
      width: 420,
      height: 236,
      isMobile: false,
      currentMode: 'middle',
    };
  },
  computed: {
    useVJS() {
      return this.source.endsWith('.m3u8');
    },
    useOverlayHandle() {
      return this.useVJS || this.source.includes('youtube') || this.source.includes('vimeo');
    },
  },
  methods: {
    drag(left, top) {
      this.left = left;
      this.top = top;
    },
    resize(left, top, width, height) {
      this.left = left;
      this.top = top;
      this.width = width;
      this.height = height;
    },
    enterMiddleSize() {
      if (this.isMobile) {
        this.width = window.innerWidth;
        this.height = Math.floor(window.innerHeight / 2);
        this.left = 0;
        this.top = Math.floor(window.innerHeight / 2);
      } else {
        this.width = Math.floor(window.innerWidth / 2.5);
        this.height = Math.floor(window.innerHeight / 2.6);
        this.left = Math.floor((window.innerWidth - this.width) * 0.95);
        this.top = Math.floor((window.innerHeight - this.height) * 0.95);
      }
      this.currentMode = 'middle';
    },
    enterFullSize() {
      this.left = 0;
      this.top = 0;
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.currentMode = 'full';
    },
    closePIP() {
      this.$emit('close');
    },
    windowResized(e) {
      this.isMobile = window.innerWidth < 768;
      if (this.currentMode === 'full') this.enterFullSize();
      else this.enterMiddleSize();

      this.enterMiddleSize();
    },
  },
  beforeMount() {
    this.windowResized();
  },
  mounted() {
    this.enterMiddleSize();
    window.addEventListener('resize', this.windowResized);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.windowResized);
  },
};
</script>

<style lang="scss">
.pip-section {
  pointer-events: none;
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100dvh;
  z-index: 10002;
}
.pip-draggable-container {
  cursor: grab;
  pointer-events: auto;
  position: absolute;
  // padding: 4px;
  background: #333;
  // border-radius: 8px;
}
.pip-content-wrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.pip-iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  // border-radius: 8px;
}
.pip-frame-overlay-handle {
  position: absolute;
  inset: 0 0 48px 0;
  z-index: 1;
}
// .pip-content-wrapper:hover > .pip-close-pip {
//   opacity: 1;
// }

.pip-close-pip {
  position: absolute;
  inset: 0 0 auto 0;
  // width: 100%;
  // margin: 10px 10px 0;
  z-index: 1001;
  background: #222;
  opacity: 0;
  transition: all 0.4s ease-in-out;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  &:hover {
    opacity: 1;
  }

  i {
    cursor: pointer;
    position: relative;
    padding: 10px;
    background: #333a;
    font-size: 1rem;
  }
}

// DRAGRESIZE STICKS
.vdr {
  border: none !important;
}
.vdr.active:before {
  outline: none !important;
}
.handle {
  background: transparent;
  border: none;
  box-shadow: none;
}

.handle-tl,
.handle-bl,
.handle-tr,
.handle-br {
  width: 20px !important;
  height: 20px !important;
}
.handle-ml,
.handle-mr {
  height: calc(100% - 20px) !important;
  transform: translateY(calc(-50% + 10px));
}

.handle-tm,
.handle-bm {
  width: calc(100% - 20px) !important;
  transform: translateX(calc(-50% + 10px));
}
</style>
